import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JhiAlertService } from 'ng-jhipster';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';
import { BrokerCertificateService } from 'src/app/client/broker-get-certificate/broker-get-certificate.service';
import { Principal, StateStorageService, User } from 'src/app/core';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { ClientService } from './../../entities/user-management/client/clinet.service';
import { CommonUtils } from 'src/app/shared/util/common-utils';
import { TypeOfClient } from 'src/app/shared/model/client.model';



@Injectable({ providedIn: 'root' })
export class CertificateRequestDataPreFill {

    private policitalRiskInvolved = false;

    constructor(
        private router: Router,
        private clientService: ClientService,
        private jhiAlertService: JhiAlertService,
        private stateStorageService: StateStorageService,
        private brokerCertificateService: BrokerCertificateService,
        private http: HttpClient,
        private principal: Principal,
    ) { }

    findCertificateRequestById(id: number, fromRevise: boolean): Observable<any> {
        if (fromRevise) {
            return this.http.get<any>(SERVER_API_URL + 'api/certificate-requests/' + id + "/" + fromRevise, { observe: 'response' });
        } else {
            return this.http.get<any>(SERVER_API_URL + 'api/certificate-requests/' + id, { observe: 'response' });
        }
    }

    viewCertificateRequest(certificateRequestId, iscargoNull: boolean, isSumInsuredNull: boolean, fromRevise: boolean) {
        console.log('CertificateRequestDataPreFill');

        this.findCertificateRequestById(certificateRequestId, fromRevise).subscribe(data => {

            this.stateStorageService.resetCertificateDTO();
            localStorage.removeItem('cargoDetail');
            localStorage.removeItem('shippingDetail');
            localStorage.removeItem('tradeDetails');
            localStorage.removeItem('lossPayee');
            localStorage.removeItem("isFavouriteOrReviseRequest");

            this.policitalRiskInvolved = data.body.politicalRiskInvolved;

            if (iscargoNull && !fromRevise) {
                data.body.cargoDetailsDTO.cargoValue = null;
            }
            if (isSumInsuredNull && !fromRevise) {
                data.body.cargoDetailsDTO.sumInsured = null;
            }

            let clientId = data.body.clientId;
            if (RoleUtil.checkForClient(this.principal.authority) && CommonUtils.isNotNil(data.body.tradeDetailsDTO) && CommonUtils.isNotNil(data.body.tradeDetailsDTO.loggedInClientId)) {
                clientId = data.body.tradeDetailsDTO.loggedInClientId;
            }
            console.log(clientId + "client id");


            data.body.id = null;
            if (this.principal.authority !== 'SPOT_CLIENT') {

                // adding extra fields to identify request is being made from fav
                if (!fromRevise) {
                    data.body.isRequestCreatedByFavourite = true;
                    data.body.createdByFavouriteRequestId = certificateRequestId;
                }

                this.stateStorageService.storeCertificateDTO(data.body);

                localStorage.setItem("lossPayee", JSON.stringify(data.body.lossPayeeDTO))

                let policyId = null;
                if (RoleUtil.checkForClient(this.principal.authority)) {
                    policyId = data.body.coAssuredId != null ? data.body.coAssuredId : data.body.policyId;
                }
                this.getClientIformation(clientId, policyId);
            } else {
                data.body.certificateRequestNumber = null;
                this.stateStorageService.storeSpotClientCertificateDTO(data.body);
                this.router.navigateByUrl("/spot-certificate/form");
            }

        });

    }


    getClientIformation(clientId, policyId) {
        this.clientService.findCertificateClient(clientId).subscribe(
            data => {
                console.log(data.body);

                let clientInfo = data.body;
                if (clientInfo.user == null) {
                    clientInfo.user = new User();
                }

                this.clientService.findPolicyIdAndCurrencyDetails(clientId, policyId).subscribe(
                    (res: HttpResponse<any>) => {
                        if (res.body) {
                            this.stateStorageService.resetClientDTO();
                            clientInfo.user.policyCurrency = res.body.name;
                            this.brokerCertificateService.policyId = res.body.id;
                            clientInfo.user.policyCurrencyValue = res.body.rate;

                            if (clientInfo.typeOfClient === TypeOfClient.TRADER) {
                                this.brokerCertificateService.clientDto = clientInfo;

                                this.stateStorageService.storeClientDTO(clientInfo);

                                if (this.policitalRiskInvolved) {
                                    if (this.principal.userIdentity.enablePoliticalRisk) {
                                        this.navigateForPoliticalRiskFlow('/certificate/political/trader');
                                    } else {
                                        this.jhiAlertService.error("Political risk is not enabled");
                                    }
                                } else {
                                    this.navigateForNormalFlow('/certificate/trader');
                                }

                            } else if (clientInfo.typeOfClient === TypeOfClient.FREIGHT_FORWARDER) {
                                this.brokerCertificateService.clientDto = clientInfo;

                                this.stateStorageService.storeClientDTO(clientInfo);
                                console.log(' this.clientInfo data setting', this.brokerCertificateService.clientDto);
                                // if (this.router.url == '/certificate/trade-Details') {
                                //     this.router.navigate(['/certificate/trade-Details'], { queryParams: { refresh: new Date().getTime() } });
                                //     //this.router.navigateByUrl('/trade-Details', { queryParams: {refresh: new Date().getTime()}});
                                // } else {
                                //     this.router.navigateByUrl('/certificate/trade-Details');
                                // }

                                    if (this.policitalRiskInvolved) {
                                    if (this.principal.userIdentity.enablePoliticalRisk) {
                                        this.navigateForPoliticalRiskFlow('/certificate/political/trade-Details');
                                    } else {
                                        this.jhiAlertService.error("Political risk is not enabled");
                                    }
                                } else {
                                    this.navigateForNormalFlow('/certificate/trade-Details');
                                }

                            }
                        } else {
                            this.jhiAlertService.error("Sorry, You don't have any active Policy!", null, null);
                        }

                    },
                    (res: any) => this.onError(res.message)
                );
            },
            err => { }
        );
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }


    // method to check if moc got change before revise
    checkForMOCChange(certificateRequestId) {
        return this.http.get(SERVER_API_URL + 'api/check-for-moc-change/' + Number(certificateRequestId) + '/true', { observe: 'response' });
    }

    navigateForNormalFlow(url) {
        if (this.router.url == url) {
            //this.router.navigateByUrl('/trader', { queryParams: {refresh: new Date().getTime()}});
            this.router.navigate([url], { queryParams: { refresh: new Date().getTime() } });
        } else {
            this.router.navigateByUrl(url);
        }
    }

    navigateForPoliticalRiskFlow(url:any) {
        if (this.router.url == url) {
            //this.router.navigateByUrl('/trader', { queryParams: {refresh: new Date().getTime()}});
            this.router.navigate([url], { queryParams: { refresh: new Date().getTime() } });
        } else {
            this.router.navigateByUrl(url);
        }
    }

}
